<ng-template #loading>
  <mat-spinner [diameter]="30" [strokeWidth]="2" [mode]="'indeterminate'"></mat-spinner>
</ng-template>

<form class="container" [formGroup]="deliveryDetailsForm" (ngSubmit)="onSubmitOrder();" [ngClass.gt-sm]="{ desktop: true }">

  <!-- columns -->
  <div class="columns">

    <section>
      <!-- buyers -->

      <h3>{{ 'DELIVERY_DETAILS.SELECT_BUYER' | translate }}</h3>

      <div class="bar">
        <app-search (queryChange)="$buyersFilter.next($event);"></app-search>
        <app-sort-button (order)="$buyersSortOrder.next($event)"></app-sort-button>
      </div>
      <ng-container formGroupName="buyer">
        <ng-container *ngIf="!(buyersApiService.loading$ | async); else loading">
          <mat-button-toggle-group #groupBuyer="matButtonToggleGroup" vertical="true" fxLayout="column" fxFlexLayout="space-between" fxLayoutGap="10px" formControlName="addressId" class="customer">
            <ng-container *ngFor="let buyer of buyersSelection$ | async">
              <mat-button-toggle value="{{buyer.address?.id}}" (click)="onSelectBuyer(buyer, buyer.address);" title="{{ buyer?.address?.full }}" [class.desktop]="mediaService.desktop$ | async">
                <div>{{ buyer.name }}<br>{{ buyer.id }}</div>
                <ul class="address">
                  <li>{{buyer.address?.name}}</li>
                  <li>{{buyer.address?.streetName}}</li>
                  <li>{{buyer.address?.cityName}} {{buyer.address?.postalCode}},</li>
                  <li>{{ buyer.address?.countryName }}</li>
                </ul>
              </mat-button-toggle>
            </ng-container>
          </mat-button-toggle-group>
        </ng-container>

      </ng-container>
      <app-paginator [input$]="buyers$" [filter$]="buyersFilter$" [$output]="$buyersSelection"></app-paginator>
    </section>

    <section>
      <!-- consignee -->

      <h3>{{ 'DELIVERY_DETAILS.SELECT_CONSIGNEES' | translate }}</h3>

      <ng-template #selectCustomerFirst>
        <p class="status">{{ 'DELIVERY_DETAILS.TEXT_SELECT_CUSTOMER_FIRST' | translate }}</p>
      </ng-template>
      <ng-template #noMatchingConsignees>
        <p class="status">{{ 'DELIVERY_DETAILS.TEXT_NO_MATCHING_CONSIGNEES' | translate }}</p>
      </ng-template>

      <div class="bar">
        <app-search (queryChange)="$consigneesFilter.next($event)"></app-search>
        <app-sort-button (order)="$consigneesSortOrder.next($event)"></app-sort-button>
      </div>
      <ng-container formGroupName="consignee" *ngIf="{ loading: consigneesApiService.loading$ | async, buyerId: buyersApiService.selectedId$ | async } as state">
        <ng-container *ngIf="!state.loading; else loading">
          <ng-container *ngIf="state.buyerId; else selectCustomerFirst">
            <ng-container *ngIf="(consigneesSelection$ | async) as consignees">
              <ng-container *ngIf="consignees.length; else noMatchingConsignees">

                <mat-button-toggle-group #groupAddresses="matButtonToggleGroup" vertical="true" fxLayout="column" fxFlexLayout="space-between" fxLayoutGap="10px" formControlName="addressId" class="customer">
                  <ng-container *ngFor="let consignee of consignees">
                    <mat-button-toggle value="{{consignee.address.id}}" (click)="onSelectConsignee(consignee, consignee.address);" ng-class="{ 'mat-accent': checked }">
                      <div title="{{consignee.address.id}}">{{ consignee.name }}<br>{{ consignee.id }}</div>
                      <ul class="address">
                        <li>{{consignee?.address?.name}}</li>
                        <li>{{consignee?.address?.streetName}}</li>
                        <li>{{consignee?.address?.cityName}} {{consignee?.address?.postalCode}},</li>
                        <li>{{consignee?.address?.countryName}}</li>
                      </ul>
                    </mat-button-toggle>
                  </ng-container>
                </mat-button-toggle-group>

              </ng-container>
            </ng-container>

          </ng-container>
          <app-paginator [input$]="consignees$" [filter$]="consigneesFilter$" [$output]="$consigneesSelection"></app-paginator>
        </ng-container>
      </ng-container>

    </section>

    <section fxLayout="column" fxLayoutAlign="flex-start stretch" fxLayoutGap="30px">

      <!-- optional fields, actions -->

      <section>
        <!-- delivery method -->

        <h3>{{ 'DELIVERY_DETAILS.SELECT_DELIVERY_TERM' | translate }}</h3>

        <ng-container formGroupName="delivery">
          <mat-button-toggle-group #groupDeliveryTerm="matButtonToggleGroup" fxLayout="row" fxFlexLayout="space-between stretch" fxLayoutGap="25px" formControlName="methodCode" class="customer">
            <mat-button-toggle value="delivery" fxFlex="50%">
              <span>{{ 'DELIVERY_DETAILS.SELECT_DELIVERY_TERM_DELIVER' | translate }}</span>
            </mat-button-toggle>
            <mat-button-toggle value="collect" fxFlex="50%">
              <span>{{ 'DELIVERY_DETAILS.SELECT_DELIVERY_TERM_COLLECT' | translate }}</span>
            </mat-button-toggle>
          </mat-button-toggle-group>
        </ng-container>

      </section>

      <section>
        <!-- delivery date -->

        <h3>{{ 'DELIVERY_DETAILS.SELECT_DELIVERY_DATE' | translate }}</h3>

        <ng-container formGroupName="delivery">
          <mat-form-field>
            <input matInput [matDatepickerFilter]="onDatepickerFilter" [matDatepicker]="deliveryDate" placeholder="{{ 'DELIVERY_DETAILS.SELECT_DELIVERY_DATE_PLACEHOLDER' | translate }}" formControlName="date">
            <mat-datepicker-toggle matSuffix [for]="deliveryDate"></mat-datepicker-toggle>
            <mat-datepicker #deliveryDate [touchUi]="true"></mat-datepicker>
          </mat-form-field>
        </ng-container>

      </section>

      <section>
        <!-- delivery details, optionals -->

        <h3>{{ 'DELIVERY_DETAILS.TITLE_OPTIONAL' | translate }}</h3>

        <ng-container formGroupName="buyer">
          <mat-form-field>
            <textarea matInput #invoiceReference placeholder="{{ 'DELIVERY_DETAILS.INPUT_BUYER_REFERENCE_PLACEHOLDER' | translate }}" matTextareaAutosize matAutosizeMinRows="1" matAutosizeMaxRows="10" maxlength="100" formControlName="reference"></textarea>
            <mat-hint align="end" *ngIf="invoiceReference.value.length > 75">{{invoiceReference.value.length}} / 100</mat-hint>
          </mat-form-field>
        </ng-container>

        <ng-container formGroupName="consignee">
          <mat-form-field>
            <textarea matInput #consigneeReference placeholder="{{ 'DELIVERY_DETAILS.INPUT_CONSIGNEE_REFERENCE_PLACEHOLDER' | translate }}" matTextareaAutosize matAutosizeMinRows="1" matAutosizeMaxRows="10" maxlength="100" formControlName="reference"></textarea>
            <mat-hint align="end" *ngIf="consigneeReference.value.length > 75">{{consigneeReference.value.length}} / 100</mat-hint>
          </mat-form-field>
        </ng-container>

        <ng-container formGroupName="delivery">
          <mat-form-field>
            <textarea matInput #deliveryInstructions placeholder="{{ 'DELIVERY_DETAILS.INPUT_DELIVERY_INSTRUCTIONS_PLACEHOLDER' | translate }}" matTextareaAutosize matAutosizeMinRows="1" matAutosizeMaxRows="10" maxlength="500" formControlName="instructions"></textarea>
            <mat-hint align="end" *ngIf="deliveryInstructions.value.length > 400">{{deliveryInstructions.value.length}} / 500</mat-hint>
          </mat-form-field>
        </ng-container>

      </section>

      <mat-checkbox formControlName="saveDetails">{{ 'DELIVERY_DETAILS.SELECT_REMEMBER_SETTINGS' | translate }}</mat-checkbox>

    </section>
  </div>

  <ng-content></ng-content>

  <div class="bottom">
    <section fxLayout="column" fxLayoutAlign="stretch" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="space-between center" fxLayoutGap="30px" [ngStyle.sm]="{'margin-top': '50px', padding: '0 10%'}" [ngStyle.xs]="{'margin-top': '50px', padding: '0 10%'}" [ngStyle.gt-sm]="{'margin-top': '20px'}">
      <ng-container *ngIf="{ valid: deliveryDetailsForm.valid && (orderService.valid$ | async) && !(ordersApiService.loading$ | async) } as state">
        <button mat-button type="submit" class="mat-elevation-z0 large" [disabled]="!state.valid" fxFlex="1 0 auto">{{ 'DELIVERY_DETAILS.ACTION_SEND_ORDER' | translate }}</button>
      </ng-container>
    </section>
  </div>

</form>
